export default __webpack_public_path__ + "static/media/test_bg.0760c1ac.png";